import request from '@/http/request'
import { createCachedApi } from '@/utils/apiCache'

var REF_TTL = 10 * 60 * 1000

// 查询案例分类列表（缓存）
export var listCategories = createCachedApi(function(query) {
    return request({
      url: '/system/case/categories/list',
      method: 'get',
      params: query
    })
}, REF_TTL)

// 查询案例列表（不缓存，数据变化频繁）
export function listCases(query) {
    return request({
      url: '/system/cases/list',
      method: 'get',
      params: query
    })
}

// 查询案例详细
export function getCases(id) {
    return request({
      url: '/system/cases/' + id,
      method: 'get'
    })
}
